import type { Filter, FilterDataRadio, FiltersGroup } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';

type ShouldShowDestinationAirportFilterProps = {
  filtersGroup: FiltersGroup | undefined;
};
export const createShouldShowDestinationAirportFilter = ({
  filtersGroup,
}: ShouldShowDestinationAirportFilterProps): boolean => {
  const destinationAirportFilter = filtersGroup?.filters?.find(
    (filter: Filter) => filter.name === FILTER_NAME.DESTINATION_AIRPORT
  );
  const filterData = destinationAirportFilter?.data as FilterDataRadio | undefined;
  const options = filterData?.options ?? [];
  const airportSelected = options.some((option) => option.selected && option.value !== filterData?.defaultValue);
  return options.length > 2 || airportSelected;
};

type ShouldShowOvernightsFilterProps = {
  filtersGroup: FiltersGroup | undefined;
};
export const createShouldShowOvernightFlightsFilter = ({ filtersGroup }: ShouldShowOvernightsFilterProps): boolean =>
  !!filtersGroup?.filters?.find((filter: Filter) => filter.name === FILTER_NAME.OVERNIGHT_FLIGHTS);
